import { getImage, GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';
import { StructuredText } from 'react-datocms';

import './styles.css'

function ContentHeroSmall({ content })
{
  return (

    <div className="mx-8">
      <div className="max-w-3xl bg-orange rounded-3xl px-14 py-8 mx-auto relative text-white mb-8">
        <div className="w-full md:w-1/2">
          {/* <h2 className="font-semibold text-2xl uppercase mb-2.5">{block.headline}</h2> */}
          <div className={"hero-small-content"}>
            <StructuredText data={content[0].text} />
          </div>
        </div>
        <div className="rounded-3xl absolute w-1/2 h-full top-0 right-0 overflow-hidden z-0 hidden md:block">
          <GatsbyImage image={getImage(content[1].text.blocks[0].image)}
            objectFit="fill"
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      </div>
    </div>

  );
}

export default ContentHeroSmall;